import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { galleries } from '../mock';

const services = {
  'wedding-photography': {
    title: 'Wedding Photographer in Lucknow | Frames by Gaurav',
    description:
      'Wedding photography in Lucknow by Frames by Gaurav. Explore ceremony, portrait and celebration photography, then enquire about your date.',
    heading: 'Wedding Photography in Lucknow',
    intro:
      'From the ceremony to the celebrations, Frames by Gaurav photographs the people, details and moments that make your wedding yours. Explore selected wedding images and get in touch to discuss coverage and availability.',
    gallery: 'wedding',
    imageDescription: 'Wedding photography',
  },
  'fashion-photography': {
    title: 'Fashion Photographer in Lucknow | Frames by Gaurav',
    description:
      'Fashion photography in Lucknow for editorial concepts, model portfolios and clothing campaigns. View selected work by Frames by Gaurav.',
    heading: 'Fashion Photography in Lucknow',
    intro:
      'Build a considered visual story for an editorial, model portfolio or fashion campaign. Browse selected fashion work and contact the studio to share your brief, references and schedule.',
    gallery: 'fashion',
    imageDescription: 'Fashion photography',
  },
  'event-photography': {
    title: 'Event Photographer in Lucknow | Frames by Gaurav',
    description:
      'Event photography in Lucknow for celebrations, conferences and corporate gatherings. View selected work and check availability.',
    heading: 'Event Photography in Lucknow',
    intro:
      'Document the people, atmosphere and important moments at your celebration, conference or corporate gathering. Contact the studio with your event type, date and venue to discuss coverage.',
    gallery: 'events',
    imageDescription: 'Event photography',
  },
  'commercial-photography': {
    title: 'Commercial Photographer in Lucknow | Frames by Gaurav',
    description:
      'Commercial photography in Lucknow for products, brands and workspaces. Explore selected images and discuss your project with Frames by Gaurav.',
    heading: 'Commercial Photography in Lucknow',
    intro:
      'Create clear, useful imagery for products, brands and workspaces. Share your goals, intended platforms and schedule with the studio to plan a commercial photography project.',
    gallery: 'commercial',
    imageDescription: 'Commercial photography',
  },
};

const ServicePage = () => {
  const { service: serviceSlug } = useParams();
  const service = services[serviceSlug];

  if (!service) return null;

  const photos = galleries[service.gallery] || [];
  const canonicalUrl = `/${serviceSlug}`;

  return (
    <>
      <SEO
        title={service.title}
        description={service.description}
        canonicalUrl={canonicalUrl}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: service.heading,
          description: service.description,
          url: `https://www.framesbygaurav.com${canonicalUrl}`,
          areaServed: { '@type': 'City', name: 'Lucknow' },
          provider: {
            '@type': 'Photographer',
            name: 'Frames by Gaurav',
            telephone: '+917398413465',
            url: 'https://www.framesbygaurav.com',
          },
        }}
      />
      <Layout>
        <main>
          <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-6">
              <p className="text-sm uppercase tracking-widest text-gray-500 mb-4">
                Frames by Gaurav · Lucknow
              </p>
              <h1 className="text-4xl md:text-6xl font-medium mb-6 tracking-tight">
                {service.heading}
              </h1>
              <p className="max-w-3xl text-lg md:text-xl text-gray-700 leading-relaxed">
                {service.intro}
              </p>
              <div className="flex flex-wrap gap-4 mt-8">
                <Link
                  to="/contact"
                  className="bg-black text-white px-7 py-3 uppercase text-sm tracking-widest hover:bg-gray-800"
                >
                  Check availability
                </Link>
                <Link
                  to="/packages"
                  className="border border-black text-black px-7 py-3 uppercase text-sm tracking-widest hover:bg-black hover:text-white"
                >
                  View packages
                </Link>
              </div>
            </div>
          </section>

          <section className="py-12 md:py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6">
              <h2 className="text-2xl md:text-3xl font-medium mb-8">
                Selected {service.imageDescription.toLowerCase()}
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {photos.slice(0, 3).map(photo => (
                  <img
                    key={photo.id}
                    src={photo.url}
                    alt={`${service.imageDescription} in Lucknow: ${photo.title}`}
                    className="w-full aspect-[4/3] object-cover"
                    loading="lazy"
                    decoding="async"
                  />
                ))}
              </div>
            </div>
          </section>
        </main>
      </Layout>
    </>
  );
};

export default ServicePage;
